import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
// config
import colors from "../../../config/colors";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
import {
  setSelectedDetailsTab,
  setSelectedSimilarCreatorDetailsTab,
} from "../../../redux/slices/creator";
// ga
import {
  triggerGa,
  CATEGORY,
  ACTION,
  PAGE,
  SCREEN,
} from "../../../utils/gaUtils";

const TABS = [
  {
    label: "Overview",
    value: "overview",
  },
  {
    label: "Content",
    value: "content",
  },
  // {
  //   label: "Similar Creators",
  //   value: "similar-creators",
  // },
];

const TabRoot = styled(Box)(() => ({
  backgroundColor: colors.primary200,
  display: "flex",
  padding: "4px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "4px",
}));

const TabContainer = styled(Box)(({ selected }) => ({
  display: "flex",
  padding: "6px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  flex: "1 0 0",
  borderRadius: "4px",
  backgroundColor: selected ? "white" : colors.primary200,
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: selected ? "white" : colors.primary100,
  },
}));

const Tabs = ({ type = "creatorDetails" }) => {
  const dispatch = useDispatch();
  const selectedTabCreatorDetails = useSelector(
    (state) => state.creator.selectedDetailsTab,
  );
  const selectedSimilarCreatorDetailsTab = useSelector(
    (state) => state.creator.selectedSimilarCreatorDetailsTab,
  );

  const selectedTab =
    type === "creatorDetails"
      ? selectedTabCreatorDetails
      : selectedSimilarCreatorDetailsTab;

  const filteredTabs =
    type === "similarCreatorDetails"
      ? TABS.filter((tab) => tab.value !== "similar-creators")
      : TABS;

  const handleTabClick = (tabValue) => {
    if (type === "creatorDetails") {
      dispatch(setSelectedDetailsTab(tabValue));
    } else {
      dispatch(setSelectedSimilarCreatorDetailsTab(tabValue));
    }
    triggerGa({
      category: CATEGORY.CREATOR_DISCOVERY,
      action: ACTION.BUTTON_CLICK,
      label: tabValue,
      page: PAGE.DISCOVER,
      screenName: SCREEN.PROFILE,
    });
  };

  return (
    <TabRoot>
      {filteredTabs.map((tab) => (
        <TabContainer
          key={tab.value}
          selected={selectedTab === tab.value}
          onClick={() => handleTabClick(tab.value)}
        >
          <Typography fontSize={14} lineHeight="20px">
            {tab.label}
          </Typography>
        </TabContainer>
      ))}
    </TabRoot>
  );
};

export default Tabs;
